import { useState } from 'react';

import { TextField, Tooltip } from '@mui/material';

import { IQuestionnaireFormWidgetProps } from 'src/features/questionnaire/domain/types';

const IntegerFieldWidget: React.FC<IQuestionnaireFormWidgetProps> = ({
	question,
	onValueChange,
	isDisabled,
	error,
	helperText = 'This field is invalid',
}) => {
	const value = question.submitted_data?.value_integer ?? '';

	const [integerFieldValue, setIntegerFieldValue] = useState(value);

	const handleValueChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		const value = parseInt(e.target.value);
		const updatedValue = isNaN(value) ? '' : value;

		setIntegerFieldValue(updatedValue);
		onValueChange(question, updatedValue, 'value_integer');
	};

	const handleWheel = (e: React.WheelEvent<HTMLInputElement>) => {
		(e.target as HTMLInputElement).blur();
	};

	const getToolTipTitle = () => {
		return (
			<span style={{ whiteSpace: 'pre-line' }}>
				Q: {question.text}
				{integerFieldValue ? `\n\nAns: ${integerFieldValue}` : ''}
			</span>
		);
	};

	return (
		<Tooltip title={getToolTipTitle()} arrow placement='left-start'>
			<TextField
				fullWidth
				label={question.text}
				required={question.is_required}
				type='number'
				value={integerFieldValue}
				disabled={isDisabled}
				InputProps={{
					inputProps: {
						step: '1',
						min: '0',
						onWheel: handleWheel,
					},
				}}
				onChange={handleValueChange}
				error={error}
				helperText={error ? helperText : ''}
				sx={{
					'& input': {
						textOverflow: 'ellipsis',
						whiteSpace: 'nowrap',
						overflow: 'hidden',
					},
				}}
			/>
		</Tooltip>
	);
};

export default IntegerFieldWidget;
